/**
 * Map Template API Service
 *
 * HTTP client for map template CRUD endpoints.
 */

import { apiClient } from './client';
import type {
  MapTemplate,
  CreateMapTemplateRequest,
  UpdateMapTemplateRequest,
} from '@/types/mapTemplate';

export const mapTemplateApi = {
  /**
   * List all map templates for a project
   */
  async listTemplates(projectId: string): Promise<{
    templates: MapTemplate[];
    total: number;
  }> {
    const response = await apiClient.get('/map-templates', {
      params: { projectId },
    });
    return response.data.data;
  },

  /**
   * Get a specific template by ID
   */
  async getTemplateById(templateId: string): Promise<MapTemplate> {
    const response = await apiClient.get(`/map-templates/${templateId}`);
    return response.data.data.template;
  },

  /**
   * Create a new map template (Save As)
   */
  async createTemplate(data: CreateMapTemplateRequest): Promise<MapTemplate> {
    const response = await apiClient.post('/map-templates', data);
    return response.data.data.template;
  },

  /**
   * Update an existing template (Save)
   */
  async updateTemplate(
    templateId: string,
    updates: UpdateMapTemplateRequest
  ): Promise<MapTemplate> {
    const response = await apiClient.put(
      `/map-templates/${templateId}`,
      updates,
    );
    return response.data.data.template;
  },

  /**
   * Delete (archive) a template
   */
  async deleteTemplate(templateId: string): Promise<void> {
    await apiClient.delete(`/map-templates/${templateId}`);
  },
};
